import { sortOnPriority } from "../ArticlesHelpers";

export class Modifiergroup {
  constructor(
    id,
    max_n,
    multiple,
    name,
    numerable,
    optional,
    priority,
    plu,
    manual_active,
    active,
    translation_id,
    meta_json,
    modifierarticleIds = [],
    articleIds = [],
    updatedAt,
    pos_name
  ) {
    this.id = id;
    this.max_n = max_n;
    this.multiple = multiple;
    this.name = name;
    this.numerable = numerable;
    this.optional = optional;
    this.priority = priority;
    this.plu = plu;
    this.manual_active = manual_active;
    this.active = active;
    this.translation_id = translation_id;
    this.modifierarticleIds = modifierarticleIds;
    this.articleIds = articleIds;
    this.meta_json = meta_json;
    this.updated_at = updatedAt;
    this.pos_name = pos_name;
  }

  getModifierarticles(modifierarticles) {
    return sortOnPriority(
      this.modifierarticleIds
        .map((modifierarticleId) => modifierarticles[modifierarticleId])
        .filter((modifierarticle) => modifierarticle)
    );
  }

  get key() {
    return this.id + "-" + this.updated_at;
  }
}

export const CreateModifiergroup = (json, modifierarticleIds, articleIds) => {
  return new Modifiergroup(
    json.id,
    json.max_n,
    json.modifiergroup.multiple,
    json.name,
    json.modifiergroup.numerable,
    json.modifiergroup.optional,
    json.priority,
    json.plu,
    json.manual_active,
    json.active,
    json.translation_id,
    json.meta_json,
    modifierarticleIds,
    articleIds,
    json.updated_at,
    json.pos_name
  );
};
